// Loads and draws SVG finger images for tutorial slides
// Right finger: rotated -90° (counter-clockwise) so finger points up
// Left finger: rotated +90° (clockwise) so finger points up

let rightFingerImg: HTMLImageElement | null = null
let leftFingerImg: HTMLImageElement | null = null
let loaded = false

export function preloadFingers(): void {
  if (loaded) return
  loaded = true

  rightFingerImg = new Image()
  rightFingerImg.src = '/assets/finger-right.svg'

  leftFingerImg = new Image()
  leftFingerImg.src = '/assets/finger-left.svg'
}

export function drawRightFinger(
  ctx: CanvasRenderingContext2D,
  x: number, z: number,
  size: number,
  alpha: number,
  scale = 1,
): void {
  if (!loaded) preloadFingers()
  if (!rightFingerImg || !rightFingerImg.complete) {
    // Fallback circle while loading
    ctx.beginPath(); ctx.arc(x, z, size * 0.3, 0, Math.PI * 2)
    ctx.fillStyle = 'rgba(255,255,255,0.3)'; ctx.globalAlpha = alpha; ctx.fill()
    return
  }
  ctx.save()
  ctx.translate(x, z)
  ctx.rotate(-Math.PI / 2) // counter-clockwise 90° — finger points up
  ctx.scale(scale, scale)
  ctx.globalAlpha = alpha
  ctx.drawImage(rightFingerImg, -size / 2, -size / 2, size, size)
  ctx.restore()
}

export function drawLeftFinger(
  ctx: CanvasRenderingContext2D,
  x: number, z: number,
  size: number,
  alpha: number,
  scale = 1,
): void {
  if (!loaded) preloadFingers()
  if (!leftFingerImg || !leftFingerImg.complete) {
    ctx.beginPath(); ctx.arc(x, z, size * 0.3, 0, Math.PI * 2)
    ctx.fillStyle = 'rgba(255,255,255,0.3)'; ctx.globalAlpha = alpha; ctx.fill()
    return
  }
  ctx.save()
  ctx.translate(x, z)
  ctx.rotate(Math.PI / 2) // clockwise 90° — finger points up
  ctx.scale(scale, scale)
  ctx.globalAlpha = alpha
  ctx.drawImage(leftFingerImg, -size / 2, -size / 2, size, size)
  ctx.restore()
}
